import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";
import {
  listMaltaEnAdmissionSignatures,
  templatesMaltaEnAdmissionCoursesSettings,
  templatesMaltaEnAcknowledgementCoursesSettings,
} from "@/src/constants/AdmissionOffice/Malta/AOMaltaEnConsts";
import {
  listPolandEnAdmissionSignatures,
  templatesPolandEnAdmissionCoursesSettings,
  templatesPolandEnAcknowledgementCoursesSettings,
} from "@/src/constants/AdmissionOffice/Poland/AOPolandEnConsts";
import {
  listUkraineEnAdmissionSignatures,
  templatesUkraineEnAdmissionCoursesSettings,
  templatesUkraineEnAcknowledgementCoursesSettings,
} from "@/src/constants/AdmissionOffice/Ukraine/AOPUkraineEnConsts";
import type { AdmissionLetterBasicCourseTemplate } from "../AdmissionLetterBasic/admissionLetterBasicRegistry";

export type AcknowledgementBodyTemplate = { tinyMCEContent: string };

export type AcknowledgementLetterBasicRegistryEntry = {
  signatures: Record<string, string>;
  admissionCourses: Record<string, AdmissionLetterBasicCourseTemplate>;
  acknowledgementCourses: Record<string, AcknowledgementBodyTemplate>;
};

export const ACKNOWLEDGEMENT_LETTER_BASIC_REGISTRY: Record<AdmissionOfficeCountry, AcknowledgementLetterBasicRegistryEntry> = {
  malta: {
    signatures: listMaltaEnAdmissionSignatures,
    admissionCourses: templatesMaltaEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    acknowledgementCourses: templatesMaltaEnAcknowledgementCoursesSettings,
  },
  poland: {
    signatures: listPolandEnAdmissionSignatures,
    admissionCourses: templatesPolandEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    acknowledgementCourses: templatesPolandEnAcknowledgementCoursesSettings,
  },
  ukraine: {
    signatures: listUkraineEnAdmissionSignatures,
    admissionCourses: templatesUkraineEnAdmissionCoursesSettings as Record<string, AdmissionLetterBasicCourseTemplate>,
    acknowledgementCourses: templatesUkraineEnAcknowledgementCoursesSettings,
  },
};
